<template>
  <admin-wrapper
    title-translation-path="admin.TASKS"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    @change="editSingleSettingHandler"
    :hasButtons="false"
    :is-form-fetched="isFormFetched"
  >
    <template #visualization.input>
      <predefined-styles class="mb-16" :layer-id="layerId" :data-source-name="dataSourceName"></predefined-styles>
    </template>
    <template #tasks_categories.input>
      <tasks-settings-categories-list />
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import PredefinedStyles from '@/components/PredefinedStyles';
import TasksSettingsCategoriesList from '@/components/TasksSettingsCategoriesList';

export default {
  name: 'TasksSettings',
  components: {
    AdminWrapper,
    PredefinedStyles,
    TasksSettingsCategoriesList,
  },
  data: () => ({
    isFormFetched: false,
  }),
  computed: {
    dataSourceName: get('admin/modulesMapping@tasks.datasource_name'),
    isModuleEnabled: get('admin/settingsValues@tasks_module_enabled'),
    modulesMapping: get('admin/modulesMapping'),
    layerId: get('admin/modulesMapping@tasks.layer_id'),
    moduleEnabler() {
      return {
        name: 'tasks_module_enabled',
        translationPath: 'admin.tasksModule',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.tasksModule') }),
      };
    },
    inputs() {
      const inputs = [
        {
          name: 'visualization',
          subtitle: `admin.tasksVisualizationSubtitle`,
          translationPath: 'admin.visualizationOnMap',
          isCustom: true,
          align: 'start',
        },
        {
          name: 'tasks_categories',
          translationPath: 'admin.categories',
          align: 'start',
        },
        {
          name: 'tasks_module_email_notifications',
          hasSuffix: false,
          translationPath: 'admin.notificationsTurnOn',
          subtitle: `admin.notificationsTurnOnSubtitle`,
          dataType: {
            name: 'switch',
          },
        },
      ];
      return inputs;
    },
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getModulesMapping: call('admin/getModulesMapping'),
    editSingleSettingHandler(value, name) {
      if (name === 'tasks_module_email_notifications') {
        this.editSingleSetting({
          key: name,
          body: {
            value,
          },
        });
      } else {
        return;
      }
    },
    async init() {
      await this.getModulesMapping();
      await this.getFeaturesLayer(this.layerId);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
